<template>
  <div>
    <div class="container">
      <form action="" class="form-horizontal">
        <div class="form-group label">
          <!-- <vs-input label="Id" type="text" class="inputx" v-model="form.id" disabled/><br> -->
          <vs-input label="Nombre" type="text" class="inputx" v-model="form.name"/><br>
          <vs-select class="ps_select" placeholder="autocomplete" autocomplete label="Vehiculo" v-model="vehicle">
          <vs-select-item :key="index" :value="item.id" :text="item.plate" v-for="item,index in vehicles"/>
          </vs-select><br>
          <vs-checkbox class="justify-content-start ps_check" v-model="form.is_ok">Activar</vs-checkbox><br>
          <vs-button class="bx bxs-paint-roll ml-3" @click="boxActivate()" color="darkgreen" type="border" icon="update">Activar</vs-button>
        </div>
      </form>
    </div>
    <br><br>
    <vs-alert class="ps_alert" color="danger" v-if="show">
          {{error_msg}}
    </vs-alert>
    <vs-alert class="ps_alert" color="success" v-if="show1">
          {{msg}}
    </vs-alert>
  </div>
  </template>
  <script>
  import axios from 'axios'
  export default {
      name: "boxEdit",
      props:{
        id: String
      },
      components: {
  },
      data:()=>({
      msg: '',
      show: false,
      show1: false,
      vehicle: String,
      vehicles: Array,
      form: {
          "id": '',
          "name": '',
          "register_key": '',
          "vehicle_id": '',
          "is_ok": false,
      },
      error_msg: ''
    }),
    methods: {
      scrollInto(elementId) {
        const section = document.querySelector(`#${elementId}`);
        section.scrollIntoView({
          behavior: 'smooth'
        });
      },
      getInfoBox(){
        const url_api =  this.$store.state.url_api
        axios.get(url_api + 'api/boxList', { params: {user_id:this.id} }).then(response => {
        this.form.id = response.data[0].id
        this.form.name = response.data[0].name
        this.form.vehicle_id = response.data[0].vehicle_id
        this.form.register_key = response.data[0].register_key
        this.form.is_ok = response.data[0].is_ok
        this.getVehicle()
        })
        .catch((error) => {
          this.error_msg = error.response.data
        })
      },
      getVehicle(){
        const url_api =  this.$store.state.url_api
        axios.get(url_api + 'api/vehicle').then(response => {
        this.vehicles = response.data
        this.vehicle = this.form.vehicle_id
        })
        .catch((error) => {
          this.error_msg = error.response.data
        })
      },
      boxActivate(){
        this.form.vehicle_id = this.vehicle
        if(this.key == undefined){this.form.key_id = ''}else{this.form.key_id = this.key}
        const url_api =  this.$store.state.url_api
        axios.post(url_api + 'api/boxActivate', this.form).then(response => {
          if (response.data == 'isOk'){
            this.show = false
            this.show1 = true
            this.msg = 'Successfully updated'
          }
          else{
            this.show = true
            this.show1 = false
            this.msg = response.data
          }
        })
        .catch((error) => {
          this.error_msg = error.response.data
          this.show = true
          this.show1 = false
        })
      },
    },
    mounted(){
      this.getInfoBox()
    }
  }
  </script>
  <style>
    .ps_alert{
      margin-top: 1em;
    }
    .label{
        text-align: left;
      }
    .vs-select--label{
      color: #000000B3;
    }
    .vs-select--item{
      color: darkgreen;
    }
  
    element.style {
        font-weight: bold;
    }
    .vs-select-primary .vs-select--item.activex {
        background: rgb(23, 83, 65);
        color: white;
    }
  </style>